import { createContext } from 'react';

// Unread chat messages for the logged-in user, shown as a badge in the nav.
// Each app computes it once in Main.tsx (useUnreadMessagesCount) and provides it;
// core screens read it to show the count or to refresh it after marking messages read.
export interface UnreadMessagesContextValue {
  totalUnreadCount: number;
  /** Refetch the count now, e.g. right after markMessagesAsRead. */
  refresh: () => void;
}

export const UnreadMessagesContext = createContext<UnreadMessagesContextValue>({
  totalUnreadCount: 0,
  refresh: () => {},
});

export const UnreadMessagesProvider = UnreadMessagesContext.Provider;
